import buildMeta from '@/router/utils/buildMeta'
import {
  userCanAccessResumeScan,
} from '../guards/resumeScan'

const routes = [
  {
    name: 'resume-optimizer',
    path: '/resume-optimizer/:opportunityId',
    beforeEnter: [userCanAccessResumeScan],
    component: () => import('@/pages/ResumeOptimizer/ResumeOptimizer.vue'),
    meta: buildMeta({
      pageTitle: 'Resume Optimizer',
      title: 'One-Click Optimize - Jobscan',
      liveChatEnabled: true,
    }),
  },
]

export default routes
